import * as React from "react";
import {Link} from "react-router-dom";

import styles from "./css/header.module.scss";
import {useDispatch} from "react-redux";
import {ClearSNSLists, SetAuthTokenAction, SetUidAction} from "../../actions";
import {IconButton, Menu, MenuItem, Tooltip} from "@material-ui/core";
import {AccountCircle, AddOutlined, SearchOutlined} from "@material-ui/icons";
import {useState} from "react";
import CachedIcon from "@material-ui/icons/Cached";
import Button from "@material-ui/core/Button";
interface HeaderProps {
    nowLogin: boolean;
    reloadTimeline: () => void;
    setOpen: (open: boolean) => void;
}

export const Header: React.SFC<HeaderProps> = (props: HeaderProps) => {
    const dispatch = useDispatch();
    const {nowLogin, reloadTimeline} = props;
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleListMenuClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleListMenuClose = () => {
        setAnchorEl(null);
    };

    return (
        <header className={styles.header}>
            <Link className={styles.headerLogo} to={nowLogin ? "/dock" : "/"}>
                <img
                    src={"/icon-192x192.png"}
                    alt="SocialDock"
                    className={styles.headerLogImg}
                />
            </Link>

            {nowLogin ? (
                <>
                    <Button
                        className={styles.reloadButton}
                        variant="contained"
                        size="small"
                        onClick={reloadTimeline}
                    >
                        <CachedIcon className={styles.reloadIcon} />
                        {window.innerWidth > 1024 ? "　タイムラインを更新" : ""}
                    </Button>
                    <Tooltip title="リストを追加">
                        <IconButton
                            aria-label="more"
                            aria-controls="long-menu"
                            aria-haspopup="true"
                            className={styles.headerPlusIcon}
                            onClick={(e) => {
                                props.setOpen(true);
                            }}
                        >
                            <AddOutlined fontSize="default" />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="検索(Coming Soon)">
                        <IconButton
                            aria-label="more"
                            aria-controls="long-menu"
                            aria-haspopup="true"
                            disableRipple
                            className={styles.headerSearchIcon}
                        >
                            <SearchOutlined fontSize="default" />
                        </IconButton>
                    </Tooltip>

                    <IconButton
                        className={styles.headerAccount}
                        aria-label="more"
                        aria-controls="long-menu"
                        aria-haspopup="true"
                        onClick={(e) => {
                            handleListMenuClick(e);
                        }}
                    >
                        <AccountCircle fontSize="large" />
                    </IconButton>
                    <Menu
                        id={`listMenu-account`}
                        anchorEl={anchorEl}
                        keepMounted
                        open={open}
                        onClose={handleListMenuClose}
                        PaperProps={{
                            style: {
                                maxHeight: 48 * 4.5,
                                width: "20ch",
                            },
                        }}
                    >
                        <MenuItem
                            onClick={() => {
                                handleListMenuClose();
                                dispatch(SetAuthTokenAction(""));
                                dispatch(SetUidAction(""));
                                dispatch(ClearSNSLists());
                                localStorage.removeItem("lastUpdatedAt");
                            }}
                        >
                            ログアウト
                        </MenuItem>
                    </Menu>
                </>
            ) : (
                <></>
            )}
        </header>
    );
};
